/*
 * Merchant: two names for the departures board — Umbrella Corp and Chief
 * Irons, both marked Raccoon City. Rides as an extra manifest row the same
 * way assets/sat-live-orders-patch.js adds a live-order row, INCLUDING —
 * per merchant follow-up — riding the exact same shared wave loop
 * (assets/sat-board-wave-patch.js) the 6 fixed rows use, instead of a
 * separate independent timer this file originally ran. That loop was
 * generalized to drive any number of bridged extra rows (see its own
 * comments); this file just registers window.SATRpdBoardBridge in the same
 * shape assets/sat-live-orders-patch.js's SATLiveBoardBridge already
 * established — count() and setStep(step, noTrans) — and owns no clock of
 * its own any more.
 *
 * SAT‑0922 / SAT‑1001 are the incident's real start/end dates (Sept 22 —
 * Oct 1), not sequential cargo codes like the other rows use.
 *
 * Same renderVals-wrapping technique as every other sat-*-patch.js file.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }

  var CELLS = [
    { city: 'RACCOON CITY, CO', code: '0922', status: 'NO CONTACT', color: '#8A3521', remark: 'C/O UMBRELLA CORP' },
    { city: 'RACCOON CITY, CO', code: '1001', status: 'NO CONTACT', color: '#8A3521', remark: 'ATTN CH. IRONS, RPD' }
  ];

  var rpdStep = 0, rpdNoTransition = false;

  window.SATRpdBoardBridge = {
    count: function () { return CELLS.length; },
    setStep: function (step, noTrans) { rpdStep = step; rpdNoTransition = noTrans; }
  };

  var orig = window.SATComponent.prototype.renderVals;
  window.SATComponent.prototype.renderVals = function () {
    var out = orig.call(this);

    if (Array.isArray(out.boardRows)) {
      var stack = CELLS.concat([CELLS[0]]).reverse();
      var max = stack.length - 1;
      var row = {
        cities: CELLS.map(function (c) { return c.city; }),
        codes: CELLS.map(function (c) { return c.code; }),
        stack: stack,
        flipTransform: 'translateY(' + (-(max - rpdStep) * 19) + 'px)',
        // Matches assets/sat-board-wave-patch.js's smooth (non-bouncy)
        // easing on the 6 fixed rows — that file's own uniform remap runs
        // before this row exists (this patch loads after it), so the
        // easing has to be set here directly, same as
        // assets/sat-live-orders-patch.js's live row does for the same
        // reason.
        flipTransition: rpdNoTransition ? 'none' : 'transform 0.42s cubic-bezier(.4,0,.2,1)',
        dotStyle: 'animation:pulseDot 1.8s ease-in-out infinite;'
      };
      out.boardRows = out.boardRows.concat([row]);
    }

    return out;
  };
})();
